import { CalendarIcon, ClockIcon, DurationIcon, FlagIcon, UserIcon } from "@xola/icons";
import { formatDate } from "@xola/ui-kit";
import clsx from "clsx";
import { isEquipmentItem, isExperienceProduct, isMerchandiseItem } from "common";
import React from "react";
import { Product, Purchase, PurchaseItem } from "types";
import { getCustomerName } from "../../models/Purchase";
import { ProductImage } from "../Common/ProductImage";
import { formatDuration } from "@/helpers/durationHelper";
import { useProduct } from "@/hooks/resources/useProduct";

interface PurchaseItemSummaryTileProps {
    purchase: Purchase;
    item: PurchaseItem;
}

export const PurchaseItemSummaryTile = ({ purchase, item }: PurchaseItemSummaryTileProps) => {
    const { product } = useProduct<Product>(item.product.id);
    const summaryProduct = product ?? item.product;
    const arrivalDateTime = "arrivalDateTime" in item ? item.arrivalDateTime : null;
    const isMerchandise = isMerchandiseItem(item);

    return (
        <div className="rounded-md bg-gray-lighter">
            <div className="space-x-4 border-b border-b-gray-light p-4 py-2 text-base font-bold">
                <FlagIcon size="medium" className="mr-2 text-yellow" />
                {getCustomerName(purchase)}
            </div>

            <div className={clsx("flex p-4", isMerchandise && "items-center")}>
                <ProductImage product={summaryProduct} size="large" />

                <div>
                    <div className="text-base font-bold" data-testid="purchase-item-summary-tile-experience">
                        {product?.name}
                    </div>
                    {arrivalDateTime ? (
                        <div className="space-x-2 text-gray-darker">
                            <span>
                                <CalendarIcon className="mr-1" />
                                <span data-testid="purchase-item-summary-tile-arrival-date">
                                    {formatDate(arrivalDateTime, "ddd ll")}
                                </span>
                            </span>
                            {"arrivalTime" in item ? (
                                <span data-testid="purchase-item-summary-tile-arrival-time">
                                    <ClockIcon className="mr-1" />
                                    {formatDate(arrivalDateTime, "LT")}
                                </span>
                            ) : null}
                        </div>
                    ) : null}
                    {isExperienceProduct(product) && product.eventDuration && (
                        <div className="text-gray-darker" data-testid="purchase-item-summary-tile-duration">
                            <DurationIcon className="mr-1" />
                            {formatDuration(product.eventDuration)}
                        </div>
                    )}
                    {!isMerchandise && (
                        <div className="text-gray-darker" data-testid="purchase-item-summary-tile-guests-count">
                            <UserIcon className="mr-1" />
                            <var data-var="guestCount">{item.quantity}</var>{" "}
                            {isEquipmentItem(item) ? "Units" : "Guests"}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
